import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import "./individualreferral.css";
import back from "../../component/images/backdown.png";

const AgentReferralTarget = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [result, setResult] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_referral/view_deliveries",
        // "http://localhost:5000/admin_referral/view_deliveries",
        {
          method: "POST",

          body: JSON.stringify({
            token: location.state.token,
            delivery_ids: location.state.delivery_ids
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      // getData(await response.json());
      const resultM = await response.json();
      setIsLoaded(true);
      if (resultM.msg === "Success") {
        setResult(resultM);
        console.log(resultM);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className='individual_referral'>
      <img
        src={back}
        width="41px"
        height="auto"
        alt="back"
        className="ref-back"
        style={{ marginBottom: "40px" }}
        onClick={handleBackClick}
      />
      {!isLoaded ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingLeft: "20vw",
          }}
        >
          <ClipLoader color={"#1FAA08"} size={100} />
        </div>
      ) : result.msg === "Success" ? (
        <table className="agent-ref-pop">
          <thead>
            <tr>
              <th>Parcel Code</th>
              <th>Sender Name</th>
              <th>Phone Number</th>
              <th>Pick-Up Address</th>
              <th>Drop-Off Address</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {result.deliveries.map((delivery) => (
              <tr key={delivery._id}>
                <td>{delivery?.parcel_code}</td>
                <td>{delivery.sender_fullname}</td>
                <td>0{delivery.sender_phone_no}</td>
                <td>{delivery.pickup_address}</td>
                <td>{delivery.drop_off_address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingLeft: "20vw",
          }}
        >
          <h1>No Deliveries found</h1>
        </div>
      )}
    </div>
  );
};

export default AgentReferralTarget;
